const STATUS = Object.freeze({
  NOT_STARTED: "#969897",
  STARTED: "#FF6200",
  COMPLETED: "#039B03",
  LEADER_APPROVED: "#067EEB",
  COUNSELOR_APPROVED: "#003f87",
  AWARDED: "#AD9D7B",
  IN_PROGRESS: "#FF6200",
  WAITING: "#FF6200",
});

export const STATUS_COLORS = Object.freeze({
  // MERIT BADGE STATUS + started and awarded:
  NOT_STARTED: STATUS.NOT_STARTED,
  COMPLETED: STATUS.COMPLETED,
  LEADER_SIGNED: STATUS.STARTED,
  LEADER_APPROVED: STATUS.LEADER_APPROVED,
  APPROVED: STATUS.LEADER_APPROVED,
  COUNSELOR_APPROVED: STATUS.COUNSELOR_APPROVED,
  AWARDED: STATUS.AWARDED,
  STARTED: STATUS.STARTED,
  checked: "#CE1126",
  // addtional RANKS requirements status
  DISABLED: STATUS.NOT_STARTED,
  EARNED: STATUS.COMPLETED,
  IN_PROGRESS: STATUS.IN_PROGRESS,
  waiting: STATUS.WAITING,
});
